import { createFileRoute } from '@tanstack/react-router';
import { SetupStepPending } from '@/pages/workspaces/broadcasts/newsletter/setup/setup-step-pending';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/schedule',
)({ component: withRumPageRendered(SetupStepPending) });
